export default "__VITE_ASSET__Dr9RBIV6__"